import React from 'react'
import './styles.scss'

const FooterSmall = () => (
  <footer className="section is-large bg-white">
    <div className="container">
      <div className="footerMisc u-margintop-large">
        <div> Copyright &copy; {new Date().getFullYear()} Catamorphic Co.</div>
      </div>
    </div>
  </footer>
)

export default FooterSmall
